'use strict';

var chunkM632V57T_js = require('./chunk-M632V57T.js');

var i=()=>({1:{fontSize:chunkM632V57T_js.a.font_size_xl,lineHeight:chunkM632V57T_js.a.font_line_height_2xl},2:{fontSize:chunkM632V57T_js.a.font_size_lg,lineHeight:chunkM632V57T_js.a.font_line_height_lg},3:{fontSize:chunkM632V57T_js.a.font_size_base,lineHeight:chunkM632V57T_js.a.font_line_height_base},4:{fontSize:chunkM632V57T_js.a.font_size_sm,lineHeight:chunkM632V57T_js.a.font_line_height_sm}}),o=()=>({bold:chunkM632V57T_js.a.font_weight_bold,semibold:chunkM632V57T_js.a.font_weight_semibold,medium:chunkM632V57T_js.a.font_weight_medium,regular:chunkM632V57T_js.a.font_weight_regular});

exports.a = i;
exports.b = o;
